<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Keys">Facilities</b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Keys">Keys</b-breadcrumb-item>
            <b-breadcrumb-item active>Add</b-breadcrumb-item>
        </b-breadcrumb>

        <form @submit.prevent="onSubmit()">
            <div class="card">
                <div class="bg-dark card-header text-white">Create New Key</div>
                <div class="card-body">
                    <div class="row">
                        <b-form-group :class="{'is-invalid': $v.facilitiesKeyTypeId.$invalid && isValidating}"
                                      class="col-lg-12" label="Key Type" v-slot="{ facilitiseKeyTypeValue }">
                            <b-form-radio-group
                              v-model="facilitiesKeyTypeId"
                              :options="facilitiesKeyTypes"
                              :aria-describedby="facilitiseKeyTypeValue"
                            ></b-form-radio-group>
                            <span class="invalid-feedback" v-if="!$v.facilitiesKeyTypeId.required && isValidating">Field is required</span>
                        </b-form-group>
                    </div>
                    <div v-if="facilitiesKeyTypeId.toUpperCase() !== facilitiesKeyTypeList.Standard" class="row">
                        <div class="col-lg-6 col-md-12 form-group">
                            <label for="buildingId">Building</label>
                            <select :class="{'is-invalid': $v.buildingId.$invalid && isValidating}"
                                    class="form-control" v-model="buildingId">
                                <option :value="null" disabled>--Select Building--</option>
                                <option :key="building.id" :value="building.id" v-for="building in buildingOptions">{{building.name}}</option>
                            </select>
                            <span class="invalid-feedback" v-if="!$v.buildingId.required && isValidating">Field is required</span>
                        </div>
                    </div>
                    <div v-if="facilitiesKeyTypeId.toUpperCase() === facilitiesKeyTypeList['Suite Master'] && buildingId !== null" class="row">
                        <div class="col-lg-6 col-md-12 form-group">
                            <label for="buildingSpaceId">Suite</label>
                            <select :class="{'is-invalid': $v.buildingSpaceId.$invalid && isValidating}"
                                    class="form-control" v-model="buildingSpaceId">
                                <option :value="null" disabled>--Select Suite--</option>
                                <option :key="buildingSpace.id" :value="buildingSpace.id" v-for="buildingSpace in buildingSpaceOptions">{{buildingSpace.spaceType}} {{buildingSpace.spaceIdentity}}</option>
                            </select>
                            <span class="invalid-feedback" v-if="!$v.buildingSpaceId.required && isValidating">Field is required</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-6 form-group">
                            <label for="keyNumber">Key Number</label>
                            <input :class="{'is-invalid': $v.keyNumber.$invalid && isValidating}"
                                    class="form-control"
                                    maxlength="30"
                                    v-model="keyNumber"/>
                            <span class="invalid-feedback" v-if="!$v.keyNumber.required && isValidating">Field is required</span>
                            <span class="invalid-feedback" v-if="!$v.keyNumber.alphaNum && isValidating">Field cannot include special characters</span>
                        </div>
                    </div>
                </div>
                <div class="card-footer d-print-none text-right">
                    <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                    <RouterLink :to="{name:'Keys'}" class="btn btn-danger">Back</RouterLink>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import {required, alphaNum, requiredIf} from "vuelidate/lib/validators";
    import FacilitiesKeysService from "@/services/FacilitiesKeysService";
    import AddressService from "@/services/AddressService";
    import BuildingSpaceService from "@/services/BuildingSpaceService";
    import { FacilitiesKeyType } from "@/services/models/FacilitiesKey";

    export default {
        data() {
            return {
                alertMessage: {
                    type: null,
                    message: null
                },
                isSubmitting: false,
                isValidating: false,
                buildingSpacesFilterOptions: {
                    returnAll: true,
                    page: 1,
                    pageSize: 10,
                    buildingId: null,
                    spaceType: null,
                    parentSpaceType: null,
                    spaceIdentity: null,
                    excludeBuildingSpaceId: null
                },
                buildingOptions: [],
                buildingSpaceOptions: [],
                buildingId: null,
                buildingSpaceId: null,
                keyNumber: null,
                facilitiesKeyTypeId: FacilitiesKeyType.Standard,
                facilitiesKeyTypeList: FacilitiesKeyType
            }
        },
        computed: {
          facilitiesKeyTypes () {
              return (Object.keys(FacilitiesKeyType)).map(val => {
                return {
                    value: FacilitiesKeyType[val],
                    text: val.toString()
                }
            })
          }
        },
        watch: {
          facilitiesKeyTypeId (newVal) {
              const vm = this;
              
              this.buildingOptions = [];
              this.buildingSpaceOptions = [];
              this.buildingId = null;
              this.buildingSpaceId = null;
              this.buildingSpacesFilterOptions = {
                  returnAll: true,
                  page: 1,
                  pageSize: 10,
                  buildingId: null,
                  spaceType: 2,
                  parentSpaceType: null,
                  spaceIdentity: null,
                  excludeBuildingSpaceId: null
              };

              if (newVal.toUpperCase() === FacilitiesKeyType['Grand Master'] || newVal.toUpperCase() === FacilitiesKeyType['Suite Master']) {
                AddressService.getAllBuildings()
                  .then(response => {
                      vm.buildingOptions = response
                  })
                  .catch(error => {
                      vm.alert(ToastType.Danger, error.response.data)
                  })
              }
          },

          buildingId (newVal) {
            const vm = this;
            if (this.facilitiesKeyTypeId.toUpperCase() === FacilitiesKeyType['Suite Master']) {
              BuildingSpaceService.getBuildingSpaces(this.buildingId, this.buildingSpacesFilterOptions)
                  .then(response => {
                      vm.buildingSpaceOptions = response.data;
                  }).catch(error => {
                      vm.alert(ToastType.Danger, error.response.data)
                  });
            }
          }
        },
        methods: {
            /**
             * @description Creates a lock and redirects if successful
             */
            onSubmit() {
                const vm = this;
                vm.isValidating = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;
                FacilitiesKeysService.addFacilitiesKey({
                  facilitiesKeyTypeId: vm.facilitiesKeyTypeId,
                  buildingId: vm.facilitiesKeyTypeId.toUpperCase() === FacilitiesKeyType['Grand Master'] ? vm.buildingId : null,
                  buildingSpaceId: vm.facilitiesKeyTypeId.toUpperCase() === FacilitiesKeyType['Suite Master'] ? vm.buildingSpaceId : null,
                  keyNumber: vm.keyNumber,
                  createdByPersonId: vm.$store.getters.user.id
                })
                    .then(response => {
                      vm.alert(ToastType.Success, "The key was successfully created");
                      const newKeyId = response;

                      // Redirect to the key details page
                      vm.$router.replace({name:'KeyDetails',params:{id:newKeyId,keyNumber:vm.keyNumber}})
                    })
                    .catch((error) => {
                      vm.alert(ToastType.Danger, error.response.data)
                    })
                    .finally(() => {
                      vm.isValidating = false;
                      vm.isSubmitting = false;
                    })
            }
        },
        validations: {
            keyNumber: {
                required,
                alphaNum
            },
            facilitiesKeyTypeId: {
              required
            },
            buildingId: {
              required: requiredIf(function () {
                return this.facilitiesKeyTypeId.toUpperCase() === FacilitiesKeyType['Grand Master'];
              })
            },
            buildingSpaceId: {
              required: requiredIf(function () {
                return this.facilitiesKeyTypeId.toUpperCase() === FacilitiesKeyType['Suite Master'];
              })
            }
        }
    }
</script>
